import { useNavigate } from "react-router-dom";
import style from './index.module.css';
export default function PromoInfo({login , setLogin,user, setUser}) {
    const navigate = useNavigate();
   

  return (
    <div className={style.page}>
         <div className={style.fire1} />
        <div className={`${style.container}`}>
            <div className={`${style.header}`}>
                <div className={style.logo} onClick={() => navigate("/")}>I’m-GPT</div>
                <div className={style.enter} onClick={() => navigate("/chat?login")}>
                    <img src='img/enter.png' alt='Войти'/>
                    <p>{login ? user?.email : 'Войти'}</p>
                </div>
            </div>
            <h1 className={style.infoph1}>Инструкция как пользоваться</h1>
            <h3 className={style.infoph3}>Нейросеть для экономии</h3>
            <div className={style.pageinfoflex}>
                <video controls>
					  <source src="video/promo.mp4" type="video/mp4"/>
                </video>
                <div className={style.rightpagepromo}>
                    <h3>Мы научили нейросеть искать действующие промокоды, чтобы каждая ваша покупка была выгоднее.</h3>
                    <div className={style.ramkapromo}>
                        <p>В этом видео вы узнаете, как пользоваться нейросетью для экономии. </p>
                        <p>Я покажу, где и как находить актуальные промокоды, как начать пользоваться сервисом с нуля и как он работает на практике. </p>
                        <p>Вы увидите пошаговую инструкцию и реальные примеры, которые помогут экономить на покупках быстро и без лишних усилий.</p>
                    </div>

                </div>
                <div className={style.flexbtn}>
                    <button className={style.btn} onClick={() => navigate("/chat?register&utm_source=promo")}>Получить доступ</button>
                    <button className={style.gredbtn} onClick={() => navigate("/")}>На главную</button>
                </div>
            </div>
        </div>
    </div>
  );
}
